import { InjectionToken } from '@angular/core'
import { DynamicElementInterceptors } from '../services'
import { DynamicElementSpecification } from './dynamic-element/dynamic-element-specification'


/**
 * Configuration used for registering how an element is dynamically created
 */
export interface DynamicElementConfig {
  /**
   * Selector that will be used to resolve and create this element
   */
  type: string

  /**
   * Tag name of the element that will be created
   */
  name: string | DynamicElementConfigResolver<string>

  /**
   * A list of aliases that will be searched. In the event of a collision with another config's type, the type will take priority.
   */
  aliases?: string[]

  /**
   * Classes that will be applied to the element unless otherwise overloaded
   */
  defaultClasses?: string | string[]

  /**
   * Collection of interceptors that will be used to modify the incoming value or returned element
   */
  interceptors?: DynamicElementInterceptors
}

export type DynamicElementConfigs = DynamicElementConfig[]

export const DYNAMIC_ELEMENT_CONFIGS = new InjectionToken<DynamicElementConfigs[]>('GPEI_DYNAMIC_ELEMENT_CONFIGS')

export type DynamicElementConfigResolver<T> = (args: DynamicElementSpecification) => T
